import { Col, FormCheck, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  register: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'radio']),
};
const defaultProps = {
  type: 'checkbox',
  label: '',
  name: '',
  items: [],
  register: (n) => n,
  disabled: false,
};

export function GroupFormCheck({
  label,
  items,
  register,
  disabled,
  name,
  type,
}) {
  const renderFormCheck = ({ value, label: fcLabel }, index) => (
    <label
      key={`formcheck-item-${index.toString()}`}
      className={classNames('d-flex', { 'mb-2': label.length > 0 })}
      htmlFor={`${name}-formcheck-${index.toString()}`}
    >
      <FormCheck
        type={type}
        {...register(name)}
        value={value}
        name={name}
        id={`${name}-formcheck-${index.toString()}`}
        disabled={disabled}
      />
      <span className="d-inline-block ms-2">{fcLabel}</span>
    </label>
  );

  return (
    <div className="form input mb-3">
      {label.length > 0 ? (
        <Row>
          <Col sm={12} xl={3} md={3} className="label-container">
            <span className="col-form-label">{label}</span>
          </Col>
          <Col sm={12} xl={9} md={9} className="field-container">
            {items.map(renderFormCheck)}
          </Col>
        </Row>
      ) : (
        <div className="d-block">{items.map(renderFormCheck)}</div>
      )}
    </div>
  );
}

GroupFormCheck.propTypes = propTypes;
GroupFormCheck.defaultProps = defaultProps;
